import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';

import JsonFormatter from './pages/JsonFormatter';
import JsonToXml from './pages/JsonToXml';
import JsonToYaml from './pages/JsonToYaml';

import XmlFormatter from './pages/XmlFormatter';
import JsonToJava from './pages/JsonToJava';
import JsonToCsv from './pages/JsonToCsv';
import XmlToCsv from './pages/XmlToJson';
import YamlToJson from './pages/YamlToJson';
import YamlFormatter from './pages/YamlFormatter';
import CsvToJson from './pages/CsvToJson';
import JsonToPhp from './pages/JsonToPhp';
import JsonToPython from './pages/JsonToPython';
import JsonToGo from './pages/JsonToGo';
import JsonToC from './pages/JsonToC';
import JsonToCpp from './pages/JsonToCpp';
import JsonToCSharp from './pages/JsonToCSharp';
import AboutUs from './pages/AboutUs';
import ContactUs from './pages/ContactUs';
import NotFound from "./pages/NotFound";
import FAQ from "./pages/FAQ";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";

import './App.css';

function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<JsonFormatter />} />
        <Route path="/json-formatter" element={<JsonFormatter />} />
        <Route path="/json-to-xml" element={<JsonToXml />} />
        <Route path="/json-to-yaml" element={<JsonToYaml />} />
        <Route path="/json-to-csv" element={<JsonToCsv />} />
        <Route path="/csv-to-json" element={<CsvToJson />} />

        <Route path="/json-to-java" element={<JsonToJava />} />
        <Route path="/json-to-php" element={<JsonToPhp />} />
        <Route path="/json-to-python" element={<JsonToPython />} />
        <Route path="/json-to-go" element={<JsonToGo />} />
        <Route path="/json-to-c" element={<JsonToC />} />
        <Route path="/json-to-cpp" element={<JsonToCpp />} />
        <Route path="/json-to-csharp" element={<JsonToCSharp />} />
		
		<Route path="/xml-formatter" element={<XmlFormatter />} />
        <Route path="/xml-to-json" element={<XmlToCsv />} />

        <Route path="/yaml-formatter" element={<YamlFormatter />} />
        <Route path="/yaml-to-json" element={<YamlToJson />} />

        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />

        {/* catch-all 404 route */}
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;